const CARD_BRAND_ICON_BASE = 'assets/images/v2/card-brands'

/** Stripe/API brand strings mapped to a card brand asset filename slug. */
const CARD_BRAND_ASSET_SLUGS: Record<string, string> = {
  visa: 'visa',
  mastercard: 'mastercard',
  amex: 'amex',
  amx: 'amex',
  american_express: 'amex',
  'american express': 'amex',
  diners: 'diners-club',
  dinners: 'diners-club',
  diners_club: 'diners-club',
  'diners club': 'diners-club',
  discover: 'discover',
  jcb: 'jcb',
  china_union_pay: 'china-union-pay',
  'china unionpay': 'china-union-pay',
  unionpay: 'china-union-pay',
  union_pay: 'china-union-pay',
  carte: 'carte',
  cartes_bancaires: 'carte',
  carte_bancaire: 'carte',
  eftpos_owler: 'eftpos-owler',
  'eftpos owler': 'eftpos-owler',
  eftpos: 'eftpos-owler'
}

/**
 * Normalize a card brand string from Stripe or the billing API.
 */
export function normalizeCardBrand(brand?: string): string | undefined {
  if (!brand) return undefined
  const key = brand.trim().toLowerCase()
  return CARD_BRAND_ASSET_SLUGS[key] ?? key
}

/**
 * Resolve the asset URL for a payment card brand icon.
 */
export function getCardBrandIconUrl(brand?: string): string {
  const slug = brand ? CARD_BRAND_ASSET_SLUGS[brand.trim().toLowerCase()] ?? 'visa' : 'visa'
  return `${CARD_BRAND_ICON_BASE}/${slug}.png`
}

/**
 * Format a card expiry date as MM/YY.
 * @param {string | number} [expMonth] Expiry month
 * @param {string | number} [expYear] Expiry year
 * @returns {string} Formatted expiry or empty string
 */
export function formatCardExpiry(expMonth?: string | number, expYear?: string | number): string {
  if (!expMonth || !expYear) return ''
  const month = String(expMonth).padStart(2, '0')
  const year = String(expYear).slice(-2)
  return `${month}/${year}`
}

/**
 * Capitalize the card brand label for display.
 * @param {string} [brand] Card brand from Stripe or the billing API
 * @returns {string} Human-readable brand label
 */
export function formatCardBrand(brand?: string): string {
  if (!brand) return ''
  const normalizeBrandName = brand.trim().toLowerCase()
  const labels: Record<string, string> = {
    amex: 'American Express',
    amx: 'American Express',
    american_express: 'American Express',
    carte: 'Carte',
    cartes_bancaires: 'Carte',
    carte_bancaire: 'Carte',
    china_union_pay: 'China Union Pay',
    diners: 'Diners Club',
    dinners: 'Diners Club',
    diners_club: 'Diners Club',
    discover: 'Discover',
    eftpos: 'eftpos',
    eftpos_owler: 'eftpos',
    jcb: 'JCB',
    mastercard: 'Mastercard',
    union_pay: 'China Union Pay',
    unionpay: 'China Union Pay',
    visa: 'Visa'
  }
  return labels[normalizeBrandName] ?? brand.charAt(0).toUpperCase() + brand.slice(1)
}
